export default class ThematicSettingsModule {
    /**
     * 
     * @param styleSettings 
     * @param territoryModel 
     * 
     * @returns 
     */
    getRequiredAttributes(styleSettings, territoryModel): string[] {
        var attrs = [];
        if (styleSettings.enabled) {
            attrs.push(styleSettings.attributeName);
        }
        
        return attrs;
    }
}
